import SandboxedHtml from '@/components/modules/custom-html/utils/sandboxed-html';
import ScriptedHtml from '@/components/modules/custom-html/utils/scripted-html';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';

export interface CustomHtmlProps extends ModuleWrapperProps {
  /** Whether to wrap the content inside the container */
  addInContainer?: Content.Components['CustomHtmlModuleDto']['addInContainer'];
  /** Render the HTML inside a sandboxed iframe */
  addInIframe?: Content.Components['CustomHtmlModuleDto']['addInIframe'];
  /** The rich text to render */
  html: Content.Components['CustomHtmlModuleDto']['html'];
}

const CustomHtml = ({
  html,
  addInContainer = false,
  addInIframe = false,
  ...rest
}: CustomHtmlProps) => {
  const hasScript = html.includes('<script');

  const content = hasScript ? (
    addInIframe ? (
      <SandboxedHtml html={html} />
    ) : (
      <ScriptedHtml html={html} />
    )
  ) : (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );

  return (
    <ModuleWrapper {...rest}>
      {addInContainer ? <Container>{content}</Container> : content}
    </ModuleWrapper>
  );
};

CustomHtml.displayName = 'CustomHtml';

export default CustomHtml;
